import FileSaver from 'file-saver';
import _ from 'lodash';
import { Action } from 'redux';

export function getCookie(name: string) {
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieToFind = name + '=';
    const cookieList = decodedCookie.split(';');

    for (let i = 0; i < cookieList.length; i++) {
        const currentCookie = cookieList[i].replace(/\s/g, '');

        if (currentCookie.indexOf(cookieToFind) === 0) {
            return currentCookie.substring(
                cookieToFind.length,
                currentCookie.length
            );
        }
    }

    return '';
}

export function setCookie(name: string, value: string) {
    document.cookie = `${name}=${value}`;
}

export function deleteCookie(name: string) {
    document.cookie = `${name}=; expires=Thu, 01-Jan-70 00:00:01 GMT;`;
}

export function deserialiseToEmpty(response: Response) {
    if (isErrorResponse(response)) {
        return deserialiseToJSON(response);
    } else {
        const emptyResponse = Promise.resolve({});
        return Promise.all([
            emptyResponse,
            Promise.resolve({
                ok: response.ok,
                url: response.url,
                type: response.type,
                status: response.status,
                bodyUsed: response.bodyUsed,
                statusText: response.statusText,
                redirected: response.redirected
            })
        ]);
    }
}

export function deserialiseToJSON(response: Response) {
    const jsonResponse = response.json();

    return Promise.all([
        jsonResponse,
        Promise.resolve({
            ok: response.ok,
            url: response.url,
            type: response.type,
            status: response.status,
            bodyUsed: response.bodyUsed,
            statusText: response.statusText,
            redirected: response.redirected
        })
    ]);
}

export function deserialiseToHTML(response: Response) {
    return Promise.all([
        response.text().then((html) => ({ data: html })),
        Promise.resolve({
            ok: response.ok,
            url: response.url,
            type: response.type,
            status: response.status,
            bodyUsed: response.bodyUsed,
            statusText: response.statusText,
            redirected: response.redirected
        })
    ]);
}

export function downloadAsAttachment(response: Response) {
    if (isErrorResponse(response)) {
        return deserialiseToJSON(response);
    } else {
        const filename = getFilename(response);
        return Promise.all([
            response.blob().then((body) => {
                const blob = new Blob([body], { type: 'application/pdf' });
                FileSaver.saveAs(blob, filename);
            }),
            Promise.resolve({
                ok: response.ok,
                url: response.url,
                type: response.type,
                status: response.status,
                bodyUsed: response.bodyUsed,
                statusText: response.statusText,
                redirected: response.redirected
            })
        ]);
    }
}

export function isErrorResponse(meta: any) {
    return _.get(meta, 'status') >= 400;
}

export function buildOptionsFromDefault(
    overrideOptions = {},
    overrideHeaders: Headers
) {
    return {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'X-CSRFToken': getCookie('csrftoken'),
            'Content-Type': 'application/json',
            ...overrideHeaders
        },
        ...overrideOptions
    };
}

export function getAPIMethodFromAction(actionName: string) {
    return decomposeFromAction(actionName)[1];
}

export function getAPINameFromAction(actionName: string) {
    return decomposeFromAction(actionName)[2];
}

export function getAPIStatusFromAction(actionName: string) {
    return decomposeFromAction(actionName)[4];
}

function decomposeFromAction(actionName: string) {
    if (actionName && _.startsWith(actionName, 'api/')) {
        return /^api\/([^_]+)_(\w*)\s?(\[(\w+)\])?/g.exec(actionName)!;
    } else {
        return [];
    }
}

function getFilename(response: Response) {
    const contentDisposition = response.headers.get('Content-Disposition')!;
    return /filename="(.+)"/.exec(contentDisposition)![1];
}

export function isFailedAPIAction(action: Action) {
    return /api\/.+ \[fail\]/.test(action.type);
}
